import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Container, List, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CommentItem from './CommentItem';
import NewComment from './NewComment';
import { addAlert } from '../../actions/alerts.action';
import { useDispatch } from 'react-redux';
import { fetchComments } from '../../api/objective/comment.api';
import { useQuery } from 'react-query';

const useStyles = makeStyles({
  container: {
    backgroundColor: '#F4F4F4',
    padding: '20px'
  },
  title: {
    color: '#999999',
    fontSize: '16px',
    textTransform: 'uppercase'
  }
});

const CommentsList = ({ objectiveId, employee }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const commentsQuery = useQuery(
    [ 'comments', objectiveId ],
    async () => {
      const { data } = await fetchComments({
        objectiveId }
      );
      data.sort((x, y) => new Date(x.created_at) - new Date(y.created_at));
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  return (
    <Container className={ classes.container }>
      <Typography className={ classes.title }>
        { t('objective.comments.title') }
      </Typography>
      <List>
        { commentsQuery.data?.map(comment => (
          <CommentItem
            key={ comment.comment_id }
            comment={ comment }
            objectiveId={ objectiveId }
            employeeId={ employee.employee_id }
            onSubmitSuccess={ commentsQuery.refetch }
          />
        ))}
      </List>
      <NewComment
        objectiveId={ objectiveId }
        onSubmitSuccess={ commentsQuery.refetch }
      />
    </Container>
  );
};

export default CommentsList;
